<template>
  <div class="input-group" :class="{'input-group-invalid': isInvalid, 'input-group-disabled': isDisabled}">
    <label>
      <FieldLabel :is-required="isRequired" :label-link-text="labelLinkText" :label-link-url="labelLinkUrl"><slot>{{ label }}</slot></FieldLabel>
      <input
          v-mask="mask"
          type="tel"
          :disabled="isDisabled"
          :placeholder="placeholder"
          v-model="inputValue"
          @blur="() => validate()"
          @input="() => inputHandle()"
      >
    </label>
  </div>
</template>

<script>
import { vMaska } from 'maska'
import {defaultProps} from "./defaultProps";
import {validTel} from "../../services/validation/validTel";

export default {
  name: "i-tel",
  props: {
    ...defaultProps,
    mask: {
      type: [Array, String],
      default: () => ['(', /\d/, /\d/, ') ', /\d?/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
    }
  },
  data: () => ({
    inputValue: null,
    isInvalid: false,
    hasTouched: false,
  }),
  directives: {
    mask: vMaska
  },
  methods: {
    inputHandle() {
      this.hasTouched = true;
      this.$emit('input', this.inputValue);
    },
    validate() {
      this.isInvalid = (!validTel(this.inputValue) && this.hasTouched)
          || (this.hasTouched && this.inputValue === null)
          || (this.isRequired && !this.inputValue);
    },
    clean() {
      this.inputValue = null;
      this.isInvalid = false;
      this.hasTouched = false;
    },
    isValid() {
      this.validate();
      return !this.isInvalid;
    },
  },
  watch: {
    value: {
      handler(v) {
        this.inputValue = v;
      },
      immediate: true,
    },
  },
}
</script>

<style scoped>

</style>
